import { Stack } from '@koob/margaret';
import { KoobButton, KoobTooltip } from '@koob/ui';
import { groupBy, sortBy, values } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css, useTheme } from 'styled-components';
import { Text } from 'ui';
import {
  LigneHorizontal,
  SubSectionTitle,
  SubSectionTitleContainer,
} from './Base';
import sanitizeHtml from 'sanitize-html';

const Icon = styled.img`
  height: 20px;
  width: 20px;
`;

const IconPlaceholder = styled.div`
  height: 20px;
  width: 20px;
`;

const GroupTitle = styled(Text).attrs({ type: 'h4' })`
  font-weight: 700;
  margin-top: 30px;
`;

const ServiceAndFacilities = ({ hotel }) => {
  const { t } = useTranslation('hotel');
  const [isShown, setIsShown] = useState(false);
  const theme = useTheme();

  const hotelFacilities = hotel?.hotelFacilities;
  const groupesQuery = sortBy(
    values(
      groupBy(hotelFacilities, ({ facility }) => {
        if (facility.groups.length === 0) {
          return '-42';
        }
        return facility.groups[0].id;
      }),
    ),
  );

  let groupes = [];
  groupesQuery.forEach((item, index) => {
    let groupe = {
      title: t('otherFacility'),
      liste: [],
    };
    if (index <= 4 && !isShown) {
      if (item[0].facility.groups.length !== 0) {
        groupe.title = item[0].facility.groups[0].displayName;
      }
      item.forEach(element => {
        let facility = {
          name: element.facility.displayName,
          icone: element.facility.iconUrl,
        };
        groupe.liste.push(facility);
      });
      groupes.push(groupe);
    } else if (isShown) {
      if (item[0].facility.groups.length !== 0) {
        groupe.title = item[0].facility.groups[0].displayName;
      }
      item.forEach(element => {
        let facility = {
          name: element.facility.displayName,
          icone: element.facility.iconUrl,
          description: element.details,
        };
        groupe.liste.push(facility);
      });
      groupes.push(groupe);
    }
  });

  return (
    <>
      {hotel?.hotelFacilities.length > 0 && (
        <Stack size="full" direction="column">
          <SubSectionTitleContainer>
            <SubSectionTitle>{t('servicesAndFacilities')}</SubSectionTitle>
          </SubSectionTitleContainer>

          <div className="grid grid-cols-2 gap-4 mt">
            {(groupes || []).map((item, index) => (
              <div className={index > 1 ? 'mt-6' : ''} key={index}>
                <div>
                  <GroupTitle>{item.title}</GroupTitle>
                  {(item.liste || []).map((facility, indx) => (
                    <div
                      className="mt-2 max-w-5xl flex items-center"
                      key={indx}
                    >
                      {facility.icone !== '' ? (
                        <Icon src={facility.icone} />
                      ) : (
                        <IconPlaceholder />
                      )}
                      <span className="ml-5">{facility.name}</span>
                      {facility.description &&
                        facility.description.length > 0 && (
                          <KoobTooltip tip={sanitizeHtml(facility.description)}>
                            <i
                              className="fa-regular fa-triangle-exclamation"
                              style={{ marginLeft: 5, color: theme.grey }}
                            />
                          </KoobTooltip>
                        )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <KoobButton
            variant="secondary"
            size="lg"
            style={{ marginTop: 50, fontWeight: 'bold' }}
            onClick={() => setIsShown(!isShown)}
          >
            {isShown ? t('services.hide') : t('services.show')}
          </KoobButton>

          <LigneHorizontal />
        </Stack>
      )}
    </>
  );
};

export default ServiceAndFacilities;
